import {
  notEmptyString,
} from '@populateui/utils';
import {
  LeanClaimSummaryDTO,
} from 'dtos/leanClaimSummaryDTO';

export function isValidTransition(
  claim: LeanClaimSummaryDTO,
  targetStatus: string,
) {
  return (claim.validManualStatusTransitions ?? [])
    .includes(targetStatus) && claim.status !== targetStatus;
}

export function validateClaimsByTargetStatus(
  claims: LeanClaimSummaryDTO[],
  targetStatus: string,
) {
  const eligible: LeanClaimSummaryDTO[] = [];
  const ineligible: LeanClaimSummaryDTO[] = [];

  if (notEmptyString(targetStatus)) {
    claims.forEach((claim) => {
      if (isValidTransition(claim, targetStatus)) {
        eligible.push(claim);
      } else {
        ineligible.push(claim);
      }
    });
  }

  return {
    eligibleClaims: eligible,
    ineligibleClaims: ineligible,
  };
}
